import React, { useState, useEffect, useCallback } from 'react'
import styles from './styles.module.scss'

type ToastType = 'success' | 'error'

interface ToastState {
    message: string
    type: ToastType
    visible: boolean
}

let showToastGlobal: ((message: string, type: ToastType) => void) | null = null

export const toast = {
    success: (message: string) => showToastGlobal?.(message, 'success'),
    error: (message: string) => showToastGlobal?.(message, 'error'),
}

const Toast: React.FC = () => {
    const [state, setState] = useState<ToastState>({ message: '', type: 'success', visible: false })

    const hide = useCallback(() => {
        setState((prev) => ({ ...prev, visible: false }))
    }, [])

    const show = useCallback((message: string, type: ToastType) => {
        setState({ message, type, visible: true })
    }, [])

    useEffect(() => {
        showToastGlobal = show
        return () => {
            showToastGlobal = null
        }
    }, [show])

    useEffect(() => {
        if (!state.visible) return
        // Longer errors (e.g. duplicate claim) need more time to read on mobile
        const duration = state.type === 'error' && state.message.length > 80 ? 7000 : 4000
        const timer = setTimeout(hide, duration)
        return () => clearTimeout(timer)
    }, [state.visible, state.message, state.type, hide])

    return (
        <div
            className={`${styles.toast} ${state.visible ? styles.visible : ''} ${state.type === 'error' ? styles.error : styles.success}`}
        >
            <span className={styles.icon}>{state.type === 'success' ? '✓' : '✕'}</span>
            <span className={styles.message}>{state.message}</span>
        </div>
    )
}

export default Toast
